module.exports = __webpack_public_path__ + "img/1.822f3570.jpg";